// extracted by mini-css-extract-plugin
module.exports = {"comp":"E_comp__DjIWC"};